import React from "react";
import Header from "../component/header";
import Footer from "../component/footer";
import { Link } from "react-router-dom";
import "../ReturnToHome.css";

const NotFound = () => {
  return (
    <>
      <Header />
      <div
        style={{
          minHeight: "85vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h1 style={{ fontSize: "4rem", margin: 0 }}>404</h1>
        <h2 style={{ margin: "1rem 0" }}>Page Not Found</h2>
        <p>The page you are looking for does not exist or has been moved.</p>
        <div className="ReturnToHome">
          <Link to="/" className="btn">
            <span>Return To Home</span>
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
